import{useState as f,useCallback as u,useEffect as l}from"react";function M({onMouseEnter:e,onMouseLeave:o,disabled:n}={}){const[r,s]=f(!1),c=u(t=>{e&&e(t),s(!0)},[e]),a=u(t=>{o&&o(t),s(!1)},[o]);return l(()=>{n&&s(!1)},[n]),[r,{onMouseEnter:c,onMouseLeave:a}]}export{M as useIsHover};
//# sourceMappingURL=index.js.map
